module.exports = __webpack_public_path__ + "8d305bd53e39cf185eb84f60c9261f8a.fbx";